import script from "./InformationScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationScreen.vue?vue&type=script&setup=true&lang=js"

import "./InformationScreen.vue?vue&type=style&index=0&id=15ad9cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ad9cce"]])

export default __exports__